import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import MarkAttendance from './MarkAttendance';
import UploadMarks from './UploadMarks';
import Announcements from './Announcements';
import Assignments from './Assignments';
import Quizzes from './Quizzes';
import SubjectContent from './SubjectContent';
import TeacherTimetable from './TeacherTimetable';

const Dashboard = () => {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'attendance', label: 'Mark Attendance', icon: '✅' },
    { id: 'marks', label: 'Upload Marks', icon: '📊' },
    { id: 'announcements', label: 'Announcements', icon: '📢' },
    { id: 'assignments', label: 'Assignments', icon: '📝' },
    { id: 'quizzes', label: 'Quizzes', icon: '❓' },
    { id: 'content', label: 'Subject Content', icon: '📚' },
    { id: 'timetable', label: 'My Timetable', icon: '📅' },
  ];

  const handleMenu = (id) => {
    setActiveMenu(id);
    navigate(`/teacher/${id}`);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={styles.container}>
      {/* Mobile Overlay */}
      {sidebarOpen && isMobile && (
        <div onClick={() => setSidebarOpen(false)} style={styles.overlay} />
      )}

      {/* Sidebar */}
      <div style={{
        ...styles.sidebar,
        left: isMobile ? (sidebarOpen ? '0' : '-260px') : '0',
        transition: 'left 0.3s ease',
        zIndex: 1000,
      }}>
        <div style={styles.sidebarHeader}>
          <img src="/logo.png" alt="logo" style={styles.logo} />
          <h3 style={styles.collegeName}>Stars College</h3>
          <p style={styles.campusName}>Tibbi Qaisrani Campus</p>
        </div>
        <div style={styles.userInfo}>
          <div style={styles.avatar}>
            {user?.profile_pic
              ? <img src={`http://localhost:5000/uploads/${user.profile_pic}`}
                  alt="" style={styles.avatarImg} />
              : user?.name?.charAt(0).toUpperCase()
            }
          </div>
          <div>
            <p style={styles.userName}>{user?.name}</p>
            <p style={styles.userRole}>Teacher</p>
          </div>
        </div>
        <nav style={styles.nav}>
          {menuItems.map(item => (
            <button key={item.id}
              style={{ ...styles.navItem, ...(activeMenu === item.id ? styles.navItemActive : {}) }}
              onClick={() => handleMenu(item.id)}>
              <span>{item.icon}</span> {item.label}
            </button>
          ))}
        </nav>
        <button onClick={handleLogout} style={styles.logoutBtn}>
          🚪 Logout
        </button>
      </div>

      {/* Main Content */}
      <div style={{
        ...styles.mainContent,
        marginLeft: isMobile ? '0' : '250px',
      }}>
        <div style={styles.topBar}>
          {isMobile && (
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={styles.hamburger}>
              ☰
            </button>
          )}
          <h2 style={styles.pageTitle}>Teacher Panel</h2>
          <p style={styles.welcome}>Welcome, {user?.name}!</p>
        </div>
        <div style={styles.content}>
          <Routes>
            <Route path="/" element={<TeacherHome user={user} />} />
            <Route path="/dashboard" element={<TeacherHome user={user} />} />
            <Route path="/attendance" element={<MarkAttendance />} />
            <Route path="/marks" element={<UploadMarks />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/assignments" element={<Assignments />} />
            <Route path="/quizzes" element={<Quizzes />} />
            <Route path="/content" element={<SubjectContent />} />
            <Route path="/timetable" element={<TeacherTimetable />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const TeacherHome = ({ user }) => (
  <div>
    <h3 style={{ color: '#1a6b3a', marginBottom: '20px' }}>
      Welcome, {user?.name}!
    </h3>
    <div style={styles.statsGrid}>
      {[
        { icon: '✅', label: 'Mark Attendance' },
        { icon: '📊', label: 'Upload Marks' },
        { icon: '📢', label: 'Announcements' },
        { icon: '❓', label: 'Create Quizzes' },
        { icon: '📝', label: 'Assignments' },
        { icon: '📚', label: 'Upload Content' },
      ].map((item, i) => (
        <div key={i} style={styles.statCard}>
          <h2 style={styles.statIcon}>{item.icon}</h2>
          <p style={styles.statLabel}>{item.label}</p>
        </div>
      ))}
    </div>
  </div>
);

const styles = {
  container: { display: 'flex', minHeight: '100vh', fontFamily: 'Arial, sans-serif' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 },
  sidebar: {
    width: '250px',
    background: 'linear-gradient(180deg, #1a6b3a 0%, #0d4a2a 100%)',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    height: '100vh',
    overflowY: 'auto',
  },
  sidebarHeader: { textAlign: 'center', padding: '20px 15px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  logo: { width: '60px', height: '60px', borderRadius: '50%' },
  collegeName: { color: 'white', fontSize: '16px', margin: '8px 0 2px' },
  campusName: { color: 'rgba(255,255,255,0.6)', fontSize: '11px', margin: 0 },
  userInfo: { display: 'flex', alignItems: 'center', gap: '10px', padding: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  avatar: { width: '36px', height: '36px', borderRadius: '50%', background: '#28a745', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '16px', overflow: 'hidden' },
  avatarImg: { width: '100%', height: '100%', objectFit: 'cover' },
  userName: { color: 'white', margin: 0, fontSize: '13px', fontWeight: 'bold' },
  userRole: { color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '11px' },
  nav: { flex: 1, padding: '10px 0' },
  navItem: { width: '100%', padding: '12px 20px', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.8)', textAlign: 'left', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '10px' },
  navItemActive: { background: 'rgba(40,167,69,0.4)', color: 'white', borderLeft: '3px solid #28a745' },
  logoutBtn: { margin: '10px 15px 20px', padding: '10px', background: 'rgba(220,53,69,0.3)', border: '1px solid rgba(220,53,69,0.5)', color: 'white', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  mainContent: { flex: 1, background: '#f5f7fa', minHeight: '100vh' },
  topBar: { background: 'white', padding: '15px 25px', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  hamburger: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#1a6b3a', marginRight: '10px' },
  pageTitle: { margin: 0, color: '#1a6b3a', fontSize: '20px' },
  welcome: { margin: 0, color: '#666', fontSize: '14px' },
  content: { padding: '25px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '20px' },
  statCard: { background: 'white', borderRadius: '12px', padding: '25px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  statIcon: { fontSize: '40px', margin: '0 0 10px' },
  statLabel: { color: '#666', fontSize: '14px', margin: 0 },
};

export default Dashboard;